import { Divider } from '@material-ui/core';
import { createElement, FC, Fragment, memo, useMemo } from 'react';

import { AddResizeFormatsButton } from '../../../../component/compound/BasicProjectSettingEditor';
import CreativeFormatOriginalItem from '../../../../component/compound/BasicProjectSettingEditor/CreativeFormatOriginalItem';
import CreativeFormatResizeItem from '../../../../component/compound/BasicProjectSettingEditor/CreativeFormatResizeItem';
import FormatDetailBlock from '../../../../component/compound/BasicProjectSettingEditor/FormatDetailBlock';
import { InputtedCreativeFormat } from '../../../../types/InputtedCreativeFormat';

type CreationSetCoreProps = {
  creativeFormat: InputtedCreativeFormat;
  onSubmitEditingAspectRatio: ({
    creativeFormatId,
    width,
    height,
  }: {
    creativeFormatId: string;
    width: number;
    height: number;
  }) => void | undefined;
  onClickDeleteButton: ({ creativeFormatId }: { creativeFormatId: string }) => void;
  resizeCreativeFormats: InputtedCreativeFormat[] | null;
  onClick: () => void;
};

const CreationSetCore: FC<CreationSetCoreProps> = ({
  creativeFormat,
  onSubmitEditingAspectRatio,
  onClickDeleteButton,
  resizeCreativeFormats,
  onClick,
}) => {
  const renderResizeCreativeFormats = useMemo(
    () =>
      resizeCreativeFormats &&
      resizeCreativeFormats.map((resizeCreativeFormat, resizeCreativeFormatIndex) => (
        <Fragment key={`resizeCreativeFormat-${resizeCreativeFormatIndex}`}>
          <CreativeFormatResizeItem
            creativeFormat={resizeCreativeFormat}
            onSubmitEditingAspectRatio={onSubmitEditingAspectRatio}
            onClickDeleteButton={onClickDeleteButton}
          />
          <Divider />
        </Fragment>
      )),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeCreativeFormats],
  );

  return (
    <Fragment>
      <FormatDetailBlock titleMessageId={'project_editing_page.basic_setting.creative_formats.original'} gridItemLg={5}>
        <CreativeFormatOriginalItem
          creativeFormat={creativeFormat}
          onSubmitEditingAspectRatio={onSubmitEditingAspectRatio}
          onClickDeleteButton={onClickDeleteButton}
        />
      </FormatDetailBlock>
      <FormatDetailBlock titleMessageId={'project_editing_page.basic_setting.creative_formats.resize'}>
        {resizeCreativeFormats ? renderResizeCreativeFormats : null}
        <AddResizeFormatsButton originalCreativeFormat={creativeFormat} onClick={onClick} />
      </FormatDetailBlock>
    </Fragment>
  );
};

export default memo(CreationSetCore);
